import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c4b7aae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = { class: "user_con" }
const _hoisted_3 = { class: "right_con" }
const _hoisted_4 = { style: {"margin":"0"} }
const _hoisted_5 = { class: "sub_title" }
const _hoisted_6 = { class: "demo" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "成交订单（笔）", -1))
const _hoisted_10 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_12 = { class: "num" }
const _hoisted_13 = { style: {"padding-left":"20px"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_15 = { style: {"font-size":"20px"} }
const _hoisted_16 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_18 = { style: {"font-size":"20px"} }
const _hoisted_19 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_21 = { style: {"font-size":"20px"} }
const _hoisted_22 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("累计成交订单：")
const _hoisted_24 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "header" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "交易额（元）", -1))
const _hoisted_28 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_30 = { class: "num" }
const _hoisted_31 = { style: {"padding-left":"20px"} }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_33 = { style: {"font-size":"20px"} }
const _hoisted_34 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_36 = { style: {"font-size":"20px"} }
const _hoisted_37 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_39 = { style: {"font-size":"20px"} }
const _hoisted_40 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("累计交易额：")
const _hoisted_42 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_43 = { class: "item" }
const _hoisted_44 = { class: "header" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "简历数量（份）", -1))
const _hoisted_46 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_48 = { class: "num" }
const _hoisted_49 = { style: {"padding-left":"20px"} }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_51 = { style: {"font-size":"20px"} }
const _hoisted_52 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_54 = { style: {"font-size":"20px"} }
const _hoisted_55 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_57 = { style: {"font-size":"20px"} }
const _hoisted_58 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_59 = /*#__PURE__*/_createTextVNode("累计简历数量：")
const _hoisted_60 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_61 = { class: "item" }
const _hoisted_62 = { class: "header" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "岗位数（个）", -1))
const _hoisted_64 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_66 = { class: "num" }
const _hoisted_67 = { style: {"padding-left":"20px"} }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_69 = { style: {"font-size":"20px"} }
const _hoisted_70 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_72 = { style: {"font-size":"20px"} }
const _hoisted_73 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_75 = { style: {"font-size":"20px"} }
const _hoisted_76 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_77 = /*#__PURE__*/_createTextVNode("累计岗位数：")
const _hoisted_78 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_79 = { class: "demo" }
const _hoisted_80 = { class: "item" }
const _hoisted_81 = { class: "header" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "用户数（人）", -1))
const _hoisted_83 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_84 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_85 = { class: "num" }
const _hoisted_86 = { style: {"padding-left":"20px"} }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_88 = { style: {"font-size":"20px"} }
const _hoisted_89 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_91 = { style: {"font-size":"20px"} }
const _hoisted_92 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_94 = { style: {"font-size":"20px"} }
const _hoisted_95 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("累计用户数：")
const _hoisted_97 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_98 = { class: "item" }
const _hoisted_99 = { class: "header" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "新增用户（人）", -1))
const _hoisted_101 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_102 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_103 = { class: "num" }
const _hoisted_104 = { style: {"padding-left":"20px"} }
const _hoisted_105 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_106 = { style: {"font-size":"20px"} }
const _hoisted_107 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_108 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_109 = { style: {"font-size":"20px"} }
const _hoisted_110 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_111 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_112 = { style: {"font-size":"20px"} }
const _hoisted_113 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_114 = /*#__PURE__*/_createTextVNode("累计用户数：")
const _hoisted_115 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_116 = { class: "item" }
const _hoisted_117 = { class: "header" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "公司数（家）", -1))
const _hoisted_119 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_120 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_121 = { class: "num" }
const _hoisted_122 = { style: {"padding-left":"20px"} }
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_124 = { style: {"font-size":"20px"} }
const _hoisted_125 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_127 = { style: {"font-size":"20px"} }
const _hoisted_128 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_129 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_130 = { style: {"font-size":"20px"} }
const _hoisted_131 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_132 = /*#__PURE__*/_createTextVNode("累计公司数：")
const _hoisted_133 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_134 = { class: "item" }
const _hoisted_135 = { class: "header" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "新增会员（人）", -1))
const _hoisted_137 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_138 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_139 = { class: "num" }
const _hoisted_140 = { style: {"padding-left":"20px"} }
const _hoisted_141 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_142 = { style: {"font-size":"20px"} }
const _hoisted_143 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_144 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_145 = { style: {"font-size":"20px"} }
const _hoisted_146 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_148 = { style: {"font-size":"20px"} }
const _hoisted_149 = {
  id: "mycharts",
  ref: "myRef",
  class: "chart-box",
  style: {"width":"100%","height":"400px"}
}
const _hoisted_150 = {
  id: "mycharts2",
  ref: "myRef2",
  class: "chart-box2",
  style: {"width":"100%","height":"400px"}
}
const _hoisted_151 = { key: 0 }
const _hoisted_152 = {
  key: 0,
  class: "shop_name"
}
const _hoisted_153 = { key: 0 }
const _hoisted_154 = {
  key: 1,
  class: "shop_name"
}
const _hoisted_155 = {
  id: "mycharts3",
  ref: "myRef2",
  class: "chart-box2",
  style: {"width":"100%","height":"400px","float":"left"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_countTo = _resolveComponent("countTo")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { class: "home" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_avatar, {
            size: 70,
            style: {"backgroundColor":"#87d068"}
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_UserOutlined)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, "欢迎进入" + _toDisplayString(_ctx.appTitle) + "后台管理，祝你开心每一天！", 1),
            _createElementVNode("div", _hoisted_5, "更新时间" + _toDisplayString(_ctx.updata_time), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.today_order_num,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.yesterday_order_num), 1),
              (_ctx.today_order_num-_ctx.yesterday_order_num>0 )
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.today_order_num-_ctx.yesterday_order_num), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.today_order_num-_ctx.yesterday_order_num<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.yesterday_order_num-_ctx.today_order_num), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.order_num), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.today_order_sum,
              duration: 3000,
              decimals: "1"
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", null, [
              _hoisted_32,
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.yesterday_order_sum), 1),
              (_ctx.today_order_sum-_ctx.yesterday_order_sum>0 )
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", _hoisted_36, _toDisplayString(parseFloat((_ctx.today_order_sum - _ctx.yesterday_order_sum).toFixed(10))), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.today_order_sum-_ctx.yesterday_order_sum<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("span", _hoisted_39, _toDisplayString(parseFloat((_ctx.yesterday_order_sum - _ctx.today_order_sum).toFixed(10))), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.order_sum), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_47
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.today_resume_num,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", null, [
              _hoisted_50,
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.yesterday_resume_num), 1),
              (_ctx.today_resume_num-_ctx.yesterday_resume_num>0 )
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("span", _hoisted_54, _toDisplayString(Number(_ctx.today_resume_num)-Number(_ctx.yesterday_resume_num)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.today_resume_num-_ctx.yesterday_resume_num<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("span", _hoisted_57, _toDisplayString(Number(_ctx.yesterday_resume_num)-Number(_ctx.today_resume_num)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.resume_num), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_65
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.today_post_num,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", null, [
              _hoisted_68,
              _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.yesterday_post_num), 1),
              (_ctx.today_post_num-_ctx.yesterday_post_num>0 )
                ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("span", _hoisted_72, _toDisplayString(Number(_ctx.today_post_num)-Number(_ctx.yesterday_post_num)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.today_post_num-_ctx.yesterday_post_num<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("span", _hoisted_75, _toDisplayString(Number(_ctx.yesterday_post_num)-Number(_ctx.today_post_num)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.post_num), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_79, [
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _hoisted_82,
          _createElementVNode("div", _hoisted_83, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_84
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_85, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.today_user_num,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", null, [
              _hoisted_87,
              _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.yesterday_user_num), 1),
              (_ctx.today_user_num-_ctx.yesterday_user_num>0 )
                ? (_openBlock(), _createElementBlock("span", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("span", _hoisted_91, _toDisplayString(Number(_ctx.today_user_num)-Number(_ctx.yesterday_user_num)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.today_user_num-_ctx.yesterday_user_num<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("span", _hoisted_94, _toDisplayString(Number(_ctx.yesterday_user_num)-Number(_ctx.today_user_num)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.user_num), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, [
          _hoisted_100,
          _createElementVNode("div", _hoisted_101, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_102
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_103, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.today_newuser_num,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", null, [
              _hoisted_105,
              _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.yesterday_newuser_num), 1),
              (_ctx.today_newuser_num-_ctx.yesterday_newuser_num>0 )
                ? (_openBlock(), _createElementBlock("span", _hoisted_107, [
                    _hoisted_108,
                    _createElementVNode("span", _hoisted_109, _toDisplayString(Number(_ctx.today_newuser_num)-Number(_ctx.yesterday_newuser_num)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.today_newuser_num-_ctx.yesterday_newuser_num<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_110, [
                    _hoisted_111,
                    _createElementVNode("span", _hoisted_112, _toDisplayString(Number(_ctx.yesterday_newuser_num)-Number(_ctx.today_newuser_num)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_113, [
            _hoisted_114,
            _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.user_num), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_116, [
        _createElementVNode("div", _hoisted_117, [
          _hoisted_118,
          _createElementVNode("div", _hoisted_119, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_120
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_121, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.today_company_num,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("div", null, [
              _hoisted_123,
              _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.yesterday_company_num), 1),
              (_ctx.today_company_num-_ctx.yesterday_company_num>0 )
                ? (_openBlock(), _createElementBlock("span", _hoisted_125, [
                    _hoisted_126,
                    _createElementVNode("span", _hoisted_127, _toDisplayString(Number(_ctx.today_company_num)-Number(_ctx.yesterday_company_num)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.today_company_num-_ctx.yesterday_company_num<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_128, [
                    _hoisted_129,
                    _createElementVNode("span", _hoisted_130, _toDisplayString(Number(_ctx.yesterday_company_num)-Number(_ctx.today_company_num)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_131, [
            _hoisted_132,
            _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.company_num), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_134, [
        _createElementVNode("div", _hoisted_135, [
          _hoisted_136,
          _createElementVNode("div", _hoisted_137, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_138
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_139, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.today_newvipuser_num,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_140, [
            _createElementVNode("div", null, [
              _hoisted_141,
              _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.yesterday_newvipuser_num), 1),
              (_ctx.today_newvipuser_num-_ctx.yesterday_newvipuser_num>0 )
                ? (_openBlock(), _createElementBlock("span", _hoisted_143, [
                    _hoisted_144,
                    _createElementVNode("span", _hoisted_145, _toDisplayString(Number(_ctx.today_newvipuser_num)-Number(_ctx.yesterday_newvipuser_num)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.today_newvipuser_num-_ctx.yesterday_newvipuser_num<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_146, [
                    _hoisted_147,
                    _createElementVNode("span", _hoisted_148, _toDisplayString(Number(_ctx.yesterday_newvipuser_num)-Number(_ctx.today_newvipuser_num)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_card, {
      title: "近30天数据统计",
      style: {"margin-top":"30px","height":"500px","width":"74.5%","float":"left"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_149, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "活跃度变化",
      style: {"height":"500px","width":"74.5%","margin-top":"30px","float":"left"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_150, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "销冠商家(前五名)",
      style: {"width":"24%","margin-left":"75%","float":"right","height":"500px","margin-top":"-1030px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: _ctx.columns,
          "data-source": _ctx.shopList,
          pagination: false,
          style: {"width":"100%"}
        }, {
          bodyCell: _withCtx(({ column, text, record,index }) => [
            (column.key === 'shop_id' && record.shop !== null )
              ? (_openBlock(), _createElementBlock("span", _hoisted_151, _toDisplayString(index+1), 1))
              : _createCommentVNode("", true),
            (column.key == 'name' && record.shop!==null )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (record.shop.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString(record.shop.name), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "招聘岗位排名(前五名)",
      style: {"margin-top":"-500px","width":"24%","margin-left":"75%","float":"right","height":"500px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: _ctx.columns2,
          "data-source": _ctx.shopList2,
          pagination: false,
          style: {"width":"100%"}
        }, {
          bodyCell: _withCtx(({ column, text, record,index }) => [
            (column.key === 'shop_id')
              ? (_openBlock(), _createElementBlock("span", _hoisted_153, _toDisplayString(index+1), 1))
              : _createCommentVNode("", true),
            (column.key === 'name' && record.shop !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(record.shop.name), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "订单营业额统计",
      style: {"width":"100%","height":"530px","float":"left","margin-top":"30px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
          onChange: _ctx.changePie
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "商品订单"
            }),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: "服务类订单"
            }),
            _createVNode(_component_a_tab_pane, {
              key: "3",
              tab: "简历"
            }),
            _createVNode(_component_a_tab_pane, {
              key: "4",
              tab: "招聘岗位"
            })
          ]),
          _: 1
        }, 8, ["activeKey", "onChange"]),
        _createElementVNode("div", _hoisted_155, null, 512)
      ]),
      _: 1
    })
  ]))
}